import { SimpleChanges } from '@angular/core';
import { PerformancePeriodicity, } from 'SecuritiesApp/ts/interfaces/attribution.interface';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { formatDateString } from 'Core/redesign/utils/date';
import { getContributorsDetractorsColorGradient } from 'SecuritiesApp/ts/utils/attribution-utils';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "SecuritiesApp/ts/services/securities.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
const _c0 = () => [];
function GainLossChartComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "ycn-loading-symbol", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("loaderMessage", ctx_r0.loadingMessage);
} }
function GainLossChartComponent_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("As of ", ctx_r0.mostRecentDate);
} }
function GainLossChartComponent_div_1_div_7_ng_container_2_a_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r2 = i0.ɵɵnextContext(2).index;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("+", ctx_r0.contributors[i_r2].contribution_points_fmtd);
} }
function GainLossChartComponent_div_1_div_7_ng_container_2_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17)(1, "div", 18)(2, "span", 19);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, GainLossChartComponent_div_1_div_7_ng_container_2_a_1_div_4_Template, 2, 1, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 21)(6, "div", 22)(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const i_r2 = i0.ɵɵnextContext().index;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("stock ", ctx_r0.contributors[i_r2].color, " col-3"));
    i0.ɵɵproperty("href", i0.ɵɵinterpolate(ctx_r0.contributors[i_r2].url), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.contributors[i_r2].security_id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.attributionView);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.contributors[i_r2].change);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("\u00A0(", ctx_r0.contributors[i_r2].change_percent, "%)");
} }
function GainLossChartComponent_div_1_div_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GainLossChartComponent_div_1_div_7_ng_container_2_a_1_Template, 11, 9, "a", 16);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r2 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext(3);
    const emptyCell_r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.contributors[i_r2])("ngIfElse", emptyCell_r3);
} }
function GainLossChartComponent_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14);
    i0.ɵɵtemplate(2, GainLossChartComponent_div_1_div_7_ng_container_2_Template, 2, 2, "ng-container", 15);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c0).constructor(8));
} }
function GainLossChartComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7)(2, "div", 8);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(3, "svg", 9);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, GainLossChartComponent_div_1_div_6_Template, 2, 1, "div", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, GainLossChartComponent_div_1_div_7_Template, 3, 2, "div", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const noData_r4 = i0.ɵɵreference(6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-pulling-up-index");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Top ", ctx_r0.contributorsLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.mostRecentDate && ctx_r0.attributionView);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.contributorsNoData)("ngIfElse", noData_r4);
} }
function GainLossChartComponent_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("As of ", ctx_r0.mostRecentDate);
} }
function GainLossChartComponent_div_2_div_7_ng_container_2_a_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r5 = i0.ɵɵnextContext(2).index;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.detractors[i_r5].contribution_points_fmtd);
} }
function GainLossChartComponent_div_2_div_7_ng_container_2_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17)(1, "div", 18)(2, "span", 19);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, GainLossChartComponent_div_2_div_7_ng_container_2_a_1_div_4_Template, 2, 1, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 21)(6, "div", 22)(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const i_r5 = i0.ɵɵnextContext().index;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("stock ", ctx_r0.detractors[i_r5].color, " col-3"));
    i0.ɵɵproperty("href", i0.ɵɵinterpolate(ctx_r0.detractors[i_r5].url), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.detractors[i_r5].security_id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.attributionView);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.detractors[i_r5].change);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("\u00A0(", ctx_r0.detractors[i_r5].change_percent, "%)");
} }
function GainLossChartComponent_div_2_div_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GainLossChartComponent_div_2_div_7_ng_container_2_a_1_Template, 11, 9, "a", 16);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r5 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext(3);
    const emptyCell_r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.detractors[i_r5])("ngIfElse", emptyCell_r3);
} }
function GainLossChartComponent_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14);
    i0.ɵɵtemplate(2, GainLossChartComponent_div_2_div_7_ng_container_2_Template, 2, 2, "ng-container", 15);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c0).constructor(8));
} }
function GainLossChartComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7)(2, "div", 8);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(3, "svg", 24);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, GainLossChartComponent_div_2_div_6_Template, 2, 1, "div", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, GainLossChartComponent_div_2_div_7_Template, 3, 2, "div", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const noData_r4 = i0.ɵɵreference(6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-pulling-down-index");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Top ", ctx_r0.detractorsLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.mostRecentDate && ctx_r0.attributionView);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.detractorsNoData)("ngIfElse", noData_r4);
} }
function GainLossChartComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25)(1, "div", 18)(2, "span", 19);
    i0.ɵɵtext(3, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 21)(5, "div", 22)(6, "span");
    i0.ɵɵtext(7, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9, "\u00A0");
    i0.ɵɵelementEnd()()()();
} }
function GainLossChartComponent_ng_template_5_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25)(1, "div", 18)(2, "span", 19);
    i0.ɵɵtext(3, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 21)(5, "div", 22)(6, "span");
    i0.ɵɵtext(7, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9, "\u00A0");
    i0.ɵɵelementEnd()()()();
} }
function GainLossChartComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14);
    i0.ɵɵtemplate(2, GainLossChartComponent_ng_template_5_div_2_Template, 10, 0, "div", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵtext(4, "No Data Available");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c0).constructor(8));
} }
export class GainLossChartComponent {
    constructor(accountsService, securitiesService) {
        this.accountsService = accountsService;
        this.securitiesService = securitiesService;
        this.attributionView = true;
        this.fetchSubscription$ = null;
        this.loading = false;
        this.contributors = [];
        this.detractors = [];
        this.errorMessage = '';
        this.detractorsNoData = true;
        this.contributorsNoData = true;
        this.mostRecentDate = '';
        this.loadingMessage = 'Loading Top Contributors/Detractors';
        this.contributorsLabel = 'Contributors';
        this.detractorsLabel = 'Detractors';
    }
    ngOnInit() {
        this.fetchSubscription$ = this.fetchAttributionData();
    }
    ngOnChanges(_changes) {
        this.fetchAttributionData();
        if (!this.attributionView) {
            this.loadingMessage = 'Loading Top Gainers and Losers';
            this.contributorsLabel = 'Gainers';
            this.detractorsLabel = 'Losers';
        }
    }
    ngOnDestroy() {
        if (this.fetchSubscription$ !== null)
            this.fetchSubscription$.unsubscribe();
    }
    fetchAttributionData() {
        if (this.fetchSubscription$ !== null)
            this.fetchSubscription$.unsubscribe();
        this.loading = true;
        return this.securitiesService
            .getContributorAndDetractorInfo(this.securityId, this.performancePeriodicity, this.holdingsLayer, this.asOfDate, this.asOfDateCustom ? formatDateString(this.asOfDateCustom) : '')
            .subscribe({
            next: (response) => {
                this.mostRecentDate = response.most_recent_date;
                this.contributors = getContributorsDetractorsColorGradient(response.contributors, true);
                this.detractors = getContributorsDetractorsColorGradient(response.detractors, false);
            },
            error: (error) => {
                this.contributors = [];
                this.detractors = [];
                this.errorMessage = error.error.error_message;
                this.loading = false;
            },
            complete: () => {
                this.loading = false;
                this.contributorsNoData = this.contributors.length === 0;
                this.detractorsNoData = this.detractors.length === 0;
            },
        });
    }
}
GainLossChartComponent.ɵfac = function GainLossChartComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GainLossChartComponent)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i2.SecuritiesService)); };
GainLossChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GainLossChartComponent, selectors: [["ycn-gain-loss-chart"]], inputs: { performancePeriodicity: "performancePeriodicity", securityId: "securityId", securityType: "securityType", asOfDateCustom: "asOfDateCustom", asOfDate: "asOfDate", holdingsLayer: "holdingsLayer", attributionView: "attributionView" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 3, consts: [["emptyCell", ""], ["noData", ""], ["class", "stocks d-flex justify-content-center align-items-center", "style", "height: 360px;", 4, "ngIf"], ["class", "stocks", 4, "ngIf"], [1, "stocks", "d-flex", "justify-content-center", "align-items-center", 2, "height", "360px"], [3, "loaderMessage"], [1, "stocks"], [1, "stocks-header"], [1, "stocks-title"], ["ycnIcon", "", 1, "text-green", 3, "name"], ["class", "panel-date", 4, "ngIf"], ["class", "stocks-body", 4, "ngIf", "ngIfElse"], [1, "panel-date"], [1, "stocks-body"], [1, "row", "no-gutters"], [4, "ngFor", "ngForOf"], ["target", "_blank", 3, "class", "href", 4, "ngIf", "ngIfElse"], ["target", "_blank", 3, "href"], [1, "stock-header"], [1, "stock-title"], ["class", "stock-label", 4, "ngIf"], [1, "stock-content"], [1, "stock-value"], [1, "stock-label"], ["ycnIcon", "", 1, "text-red", 3, "name"], [1, "stock", "bg-neutral", "col-3"], ["class", "stock bg-neutral col-3", 4, "ngFor", "ngForOf"], [1, "panel-data-empty-message"]], template: function GainLossChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, GainLossChartComponent_div_0_Template, 2, 1, "div", 2)(1, GainLossChartComponent_div_1_Template, 8, 5, "div", 3)(2, GainLossChartComponent_div_2_Template, 8, 5, "div", 3)(3, GainLossChartComponent_ng_template_3_Template, 10, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(5, GainLossChartComponent_ng_template_5_Template, 5, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
    } }, dependencies: [i3.NgForOf, i3.NgIf, i4.IconDirective, i5.LoadingSymbolComponent], encapsulation: 2 });
